import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    axios.get(`${API}/posts`).then(({ data }) => setPosts(data)).catch(() => {});
  }, []);

  return (
    <footer className="border-t border-[#D0E2FF]/60 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-1 sm:col-span-2">
            <Link to="/" className="font-display font-bold text-xl text-[#1E40AF]">Nexus Numbers</Link>
            <p className="text-xs text-[#64748B] mt-1">Paystubs &amp; Earnings Statements</p>
          </div>
          <div>
            <div className="text-xs font-semibold uppercase tracking-wider text-[#94A3B8] mb-3">Paystubs for</div>
            <ul className="space-y-2 text-sm text-[#475569]">
              <li><Link to="/self-employed-paystubs" className="hover:text-[#1E40AF]">Self-employed</Link></li>
              <li><Link to="/contractor-paystubs" className="hover:text-[#1E40AF]">Independent contractors</Link></li>
              <li><Link to="/gig-worker-proof-of-income" className="hover:text-[#1E40AF]">Gig worker income statement</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-semibold uppercase tracking-wider text-[#94A3B8] mb-3">Company</div>
            <ul className="space-y-2 text-sm text-[#475569]">
              <li><Link to="/what-is-a-paystub" className="hover:text-[#1E40AF]">What is a paystub</Link></li>
              <li><Link to="/create" className="hover:text-[#1E40AF]">Create a paystub</Link></li>
              <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#1E40AF]">Terms of Use</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-2">
            <div className="text-xs font-semibold uppercase tracking-wider text-[#94A3B8] mb-3">Learn more</div>
            <ul className="space-y-2 text-sm text-[#475569] columns-1 sm:columns-2">
              <li><Link to="/blog" data-testid="footer-blog-link" className="hover:text-[#1E40AF] font-medium">All blog posts</Link></li>
              {posts.map((p) => (
                <li key={p.id}>
                  <Link to={`/blog/${p.slug}`} data-testid={`footer-post-${p.slug}`} className="hover:text-[#1E40AF]">
                    {p.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-[#D0E2FF]/60 space-y-2">
          <p className="text-sm text-[#475569]" data-testid="footer-contact">
            <span className="font-semibold text-[#0F172A]">Contact:</span>{" "}
            <a href="mailto:nexusnumbers.help@gmail.com" className="text-[#1E40AF] hover:underline">
              nexusnumbers.help@gmail.com
            </a>
          </p>
          <p className="text-xs text-[#64748B] max-w-3xl">
            Statements must reflect actual wages paid. Creating false documents to obtain credit, housing, or benefits is illegal.
          </p>
          <p className="text-xs text-[#94A3B8]">© {new Date().getFullYear()} Nexus Numbers Paystub Generator. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
